// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Time20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Time20: FC<Time20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <path d="m12.64 13.76 1.12-1.12-2.96-2.96V6H9.2v4.32zM10 18a7.8 7.8 0 0 1-3.12-.63 8.1 8.1 0 0 1-2.54-1.71 8.1 8.1 0 0 1-1.71-2.54A7.8 7.8 0 0 1 2 10q0-1.66.63-3.12t1.71-2.54a8.1 8.1 0 0 1 2.54-1.71A7.8 7.8 0 0 1 10 2q1.66 0 3.12.63t2.54 1.71 1.71 2.54T18 10t-.63 3.12q-.63 1.46-1.71 2.54a8.1 8.1 0 0 1-2.54 1.71Q11.66 18 10 18m0-1.6q2.66 0 4.53-1.87T16.4 10t-1.87-4.53Q12.66 3.6 10 3.6T5.47 5.47 3.6 10q0 2.66 1.87 4.53T10 16.4" />
        </svg>
    );
};

export default Time20;
